(function () {
  if (window.GraceAjaxProductVariants) return;

  var activeRequest = 0;
  var prefetchCache = {};

  function getMainContent() {
    return document.getElementById('MainContent');
  }

  function unloadSectionsIn(root) {
    if (!root || !window.Shopify || !window.Shopify.theme || !window.Shopify.theme.sections) return;
    var instances = window.Shopify.theme.sections.instances || [];
    var containers = root.querySelectorAll('[data-section-type][data-section-id]');
    var ids = {};
    containers.forEach(function (el) {
      ids[el.getAttribute('data-section-id')] = true;
    });

    for (var i = instances.length - 1; i >= 0; i--) {
      var instance = instances[i];
      if (!instance || !ids[instance.id]) continue;
      try {
        if (typeof instance.onUnload === 'function') instance.onUnload();
      } catch (err) {
        console.warn('Ajax product unload error', err);
      }
      instances.splice(i, 1);
    }
  }

  function loadSectionsIn(root) {
    if (!root || !window.Shopify || !window.Shopify.theme || !window.Shopify.theme.sections) return;
    var registered = window.Shopify.theme.sections.registered || {};
    var instances = window.Shopify.theme.sections.instances || [];

    root.querySelectorAll('[data-section-type][data-section-id]').forEach(function (container) {
      var type = container.getAttribute('data-section-type');
      var id = container.getAttribute('data-section-id');
      if (!type || !id || !registered[type]) return;

      var already = instances.some(function (inst) {
        return inst && inst.id === id;
      });
      if (already) return;

      var registration = registered[type];
      var callStack = typeof registration.getStack === 'function' ? registration.getStack() : registration.callStack;
      if (!callStack) return;

      var sectionLike = {
        id: id,
        type: type,
        container: container,
        callStack: callStack,
        onLoad: function () {
          (callStack.onLoad || []).forEach(function (fn) {
            fn.call({ id: id, type: type, container: container });
          });
        },
        onUnload: function () {
          (callStack.onUnload || []).forEach(function (fn) {
            fn.call({ id: id, type: type, container: container });
          });
        },
      };

      try {
        sectionLike.onLoad();
        instances.push(sectionLike);
      } catch (err) {
        console.warn('Ajax product load error for section', id, err);
      }
    });
  }

  function replaceScripts(root) {
    root.querySelectorAll('script').forEach(function (oldScript) {
      var newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach(function (attr) {
        newScript.setAttribute(attr.name, attr.value);
      });
      if (!oldScript.src) newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function updateHeadMeta(doc) {
    if (doc.title) document.title = doc.title;

    var canonical = doc.querySelector('link[rel="canonical"]');
    var currentCanonical = document.querySelector('link[rel="canonical"]');
    if (canonical && currentCanonical) {
      currentCanonical.setAttribute('href', canonical.getAttribute('href'));
    }
  }

  function fetchProductHtml(url) {
    if (prefetchCache[url]) return prefetchCache[url];

    prefetchCache[url] = fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    }).then(function (response) {
      if (!response.ok) throw new Error('Failed to load product');
      return response.text();
    });

    return prefetchCache[url];
  }

  function applyProductHtml(html, url, pushState) {
    var main = getMainContent();
    if (!main) {
      window.location.href = url;
      return;
    }

    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var nextMain = doc.getElementById('MainContent');
    if (!nextMain) throw new Error('Missing MainContent in response');

    unloadSectionsIn(main);
    main.innerHTML = nextMain.innerHTML;
    replaceScripts(main);
    updateHeadMeta(doc);

    if (pushState !== false) {
      history.pushState({ ajaxProduct: true }, '', url);
    }

    loadSectionsIn(main);

    if (window.Shopify && window.Shopify.PaymentButton) {
      try {
        window.Shopify.PaymentButton.init();
      } catch (e) {}
    }

    document.dispatchEvent(
      new CustomEvent('ajaxProduct:loaded', {
        detail: { url: url },
      })
    );
  }

  function swapProductPage(url, pushState) {
    var main = getMainContent();
    if (!main) {
      window.location.href = url;
      return Promise.resolve();
    }

    var requestId = ++activeRequest;

    return fetchProductHtml(url)
      .then(function (html) {
        if (requestId !== activeRequest) return;
        applyProductHtml(html, url, pushState);
      })
      .catch(function (err) {
        if (requestId !== activeRequest) return;
        console.warn(err);
        window.location.href = url;
      });
  }

  function markSelected(link) {
    var group = link.closest('[data-ajax-product-variants]');
    if (!group) return;

    group.querySelectorAll('[data-ajax-product-link]').forEach(function (item) {
      item.classList.remove('mf-variants__item--current');
      item.removeAttribute('aria-current');
    });

    link.classList.add('mf-variants__item--current');
    link.setAttribute('aria-current', 'true');

    var label = link.getAttribute('data-variant-label');
    var target = group.querySelector('[data-ajax-variant-label]');
    if (target && label) target.textContent = label;
  }

  function onVariantClick(event) {
    var link = event.target.closest('[data-ajax-product-link]');
    if (!link) return;
    if (!link.closest('[data-ajax-product-variants]')) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.classList.contains('mf-variants__item--current') || link.getAttribute('aria-current') === 'true') {
      event.preventDefault();
      return;
    }

    var url = link.getAttribute('data-product-url') || link.getAttribute('href');
    if (!url) return;

    event.preventDefault();
    markSelected(link);
    swapProductPage(url, true);
  }

  function onVariantHover(event) {
    var link = event.target.closest('[data-ajax-product-link]');
    if (!link || !link.closest('[data-ajax-product-variants]')) return;
    var url = link.getAttribute('data-product-url') || link.getAttribute('href');
    if (!url || link.getAttribute('aria-current') === 'page') return;
    fetchProductHtml(url).catch(function () {
      delete prefetchCache[url];
    });
  }

  function onPopState() {
    if (!getMainContent()) return;
    swapProductPage(window.location.href, false);
  }

  function init() {
    document.addEventListener('click', onVariantClick);
    document.addEventListener('pointerenter', onVariantHover, true);
    window.addEventListener('popstate', onPopState);
  }

  window.GraceAjaxProductVariants = {
    swap: swapProductPage,
    init: init,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
